export const CATEGORY_REGEX_STRING = '[1-6]{1}';
export const SUB_CATEGORY_REGEX_STRING = '[1-6]{1}.[1-9]{1}';
export const UUID_REGEX_STRING = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
